import { useState, useContext } from "react";
import { ToastContext } from "../../../hooks/context";
import { getAllRoles } from "../../../services/settings";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { useSendUserInvite } from "../../../hooks/api/mutations/useSettings";
import { cleanObject } from "../../../helpers";

const InviteUserLogic = (closeWidget) => {
  const [inviteDetails, setInviteDetails] = useState({
    email: "",
    role: "",
    businessId: [],
    storeId: [],
    roleDescription: "",
    firstName: "",
    lastName: "",
    PhoneNumber: "",
    PhoneCode: "",
  });
  const [roleSelected, setRoleSelected] = useState("");
  const triggerToast = useContext(ToastContext);
  const { profileDetails, storeList } = useSelector(
    (state) => state.profileDetailsReducer,
  );
  const { mutate: sendInvite, isLoading } = useSendUserInvite();
  const { data: dataRoles } = useQuery(["roles"], () =>
    getAllRoles().then((res) => res.data?.data),
  );

  const inviteUser = () => {
    sendInvite(
      cleanObject({
        email: inviteDetails.email,
        role_id: inviteDetails.role,
        businesses_id: inviteDetails.businessId,
        store_id:
          inviteDetails.storeId.length > 0 ? inviteDetails.storeId : undefined,
        first_name: inviteDetails.firstName,
        last_name: inviteDetails.lastName,
        phone_number: `+${inviteDetails.PhoneCode}${inviteDetails.PhoneNumber}`,
      }),
      {
        onSuccess: () => {
          triggerToast("Invitation sent successful", "success");
          closeWidget();
        },
      },
    );
  };

  return {
    setRoleSelected,
    roleSelected,
    inviteDetails,
    setInviteDetails,
    isInviting: isLoading,
    inviteUser,
    userRoles: dataRoles
      ?.filter((item) => item?.label !== "BUSINESS MANAGER")
      .map((item) => ({
        ...item,
        label:
          item.label.charAt(0).toUpperCase() +
          item.label.slice(1).toLowerCase(),
      })),
    subAccounts: profileDetails?.business_list,
    storeList,
  };
};
export default InviteUserLogic;
